export default __webpack_public_path__ + "static/media/dynbanner4.3c392d0b.jpg";